import { useState } from 'react';
import axios from 'axios';
import auth from '@client/components/auth';

export type Configuration = {
  exerciseName: string;
  bulletForm: boolean;
  concise: boolean;
};

export type GenerateDescriptionModel = {
  generatedDescription: string;
  generate: (configuration: Configuration) => void;
};

export const useGenerateDescriptionModel = (): GenerateDescriptionModel => {
  const [generatedDescription, setGeneratedDescription] = useState<string>('');

  const generate = (configuration: Configuration) => {
    let step = 0;
    const interval = setInterval(() => {
      setGeneratedDescription('Thinking... '.slice(0, step++ % 12));
    }, 300);

    axios
      .post(
        `${import.meta.env.VITE_AI_DESCRIPTIONS_API_URL}`,
        {
          name: configuration.exerciseName,
          style: configuration.bulletForm ? 'bullet' : 'plain',
          volume: configuration.concise ? 'concise' : 'verbose',
        },
        {
          headers: {
            Authorization: auth.getToken(),
          },
        },
      )

      .then(({ data }) => setGeneratedDescription(data.result.description))
      .catch((error) => {
        console.error({ error });
        setGeneratedDescription(
          `Couldn't generate AI description, please contact the team`,
        );
      })
      .finally(() => clearInterval(interval));
  };
  return {
    generatedDescription,
    generate,
  };
};
